import { gql } from "@apollo/client";

// Only removes an assignment sitting on this very node — called on an inherited
// contact it is a no-op (the assignment lives on an ancestor). The person
// themselves is never deleted.
export const RemoveContactPersonFromInstalledBaseNode = gql`
    mutation RemoveContactPersonFromInstalledBaseNode($contactPersonId: ID!, $installedBaseNodeId: ID!) {
        removeContactPersonFromInstalledBaseNode(contactPersonId: $contactPersonId, installedBaseNodeId: $installedBaseNodeId) {
            success
            message
        }
    }
`;
